// lazy-load.directive.ts
import {
    Directive,
    ElementRef,
    AfterViewInit,
    OnDestroy,
    NgZone,
    Output,
    EventEmitter
  } from '@angular/core';

  @Directive({
    selector: '[appLazyLoad]',
    exportAs: 'appLazyLoad'
  })
  export class LazyLoadDirective implements AfterViewInit, OnDestroy {
    private observer: IntersectionObserver;
    public isVisible = false;
    @Output() visible = new EventEmitter<void>();
    constructor(
      private el: ElementRef,
      private ngZone: NgZone
    ) {}

    ngAfterViewInit() {
      this.ngZone.runOutsideAngular(() => {
        this.observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) {
            this.ngZone.run(() => {
              this.isVisible = true;
              this.visible.emit();
              this.observer.unobserve(this.el.nativeElement);
            });
          }
        }, {
          rootMargin: '0px',
          threshold: 0.5
        });

        this.observer.observe(this.el.nativeElement);
      });
    }

    ngOnDestroy() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }
